<template>
<div id="mpfollows">
  <b-field grouped group-multiline class="box">
    <date-quick @change="onDateQuick" expanded/>
    <b-datepicker
      placeholder="开始日期"
      v-model="fromDate"
      :min-date="minDate"
      :max-date="maxDate"
      :date-formatter="formatDate"
      icon="calendar-today"
      expanded
      @input="onDateInput">
    </b-datepicker>
    <b-datepicker
      placeholder="截止日期"
      v-model="toDate"
      :min-date="minDate"
      :max-date="maxDate"
      :date-formatter="formatDate"
      icon="calendar"
      expanded
      @input="onDateInput">
    </b-datepicker>
  </b-field>
  <hr />
  <b-table ref="table" :data="items"
    paginated backend-pagination
    :total="total"
    :per-page="perPage"
    :current-page="currentPage"
    @page-change="onPageChange">
    <b-table-column #default="props" field="sagiuid" label="sagiuid" width="150" numeric>
      {{ props.row.sagiuid }}
    </b-table-column>
    <b-table-column #default="props" field="nickname" label="昵称" width="300">
      {{ props.row.nickname }}
    </b-table-column>
    <b-table-column #default="props" field="createtime" label="创建时间" width="220">
      {{ formatDateTime(props.row.createtime) }}
    </b-table-column>
    <b-table-column #default="props" field="updatetime" label="更新时间" width="220">
      {{ formatDateTime(props.row.updatetime) }}
    </b-table-column>
    <b-table-column #default="props" field="status" label="状态">
        <b-tag :type="statusColor(props.row.status)"> {{ statusText(props.row.status) }}</b-tag>
    </b-table-column>
    <template #bottom-left>
      <b>总计：</b>{{ total }}
    </template>
  </b-table>
</div>
</template>

<script>
import { fromNow } from '@/core/util'
import DateQuick from '@/components/DateQuick'
import config from '@/core/config'
import cache from '@/core/cache'

export default {
  name: 'mpfollows',
  components: { DateQuick },
  mounted () {
    this.getRecord()
  },
  data: function () {
    return {
      perPage: config.PER_PAGE,
      currentPage: 1,
      total: 0,
      // 表格数据
      items: [],
      minDate: new Date(2018, 4, 12),
      maxDate: new Date(),
      fromDate: fromNow({ days: -7 }),
      toDate: new Date(),
      isLoading: false
    }
  },
  computed: {
    selectedChannels () {
      return this.$refs.channelSelector.selectedChannels
    },
    regional () {
      return cache.getR(true)
    }
  },
  methods: {
    statusColor (status) {
      return status === 1 ? 'is-success' : 'is-danger'
    },
    statusText (status) {
      return status === 1 ? '关注' : '取关'
    },
    onPageChange (page) {
      this.currentPage = page
      this.getRecord(page)
    },
    onDateQuick (date) {
      this.fromDate = date.fromDate
      this.toDate = date.toDate
    },
    onDateInput (date) {
      this.getRecord()
    },
    onChannelChange (channel) {
      this.getRecord()
    },
    buildData (data) {
      // 数据需要重新进行组合才能在图表中使用
      this.items = data.follows
      this.total = data.total
      this.perPage = data.per_page
      this.currentPage = data.page
    },
    clearRecord () {
      this.items = []
      this.total = 0
      this.perPage = config.PER_PAGE
      this.currentPage = 1
    },
    async getRecord (page) {
      console.log('isLoading: %s', this.isLoading)
      if (this.isLoading || !this.hub.checkFilters([this.regional, '区服'])) {
        this.clearRecord()
        return
      }
      page = page || this.currentPage || 1
      const filterObj = { page, per_page: this.perPage }
      if (this.fromDate) {
        filterObj.from_date = this.formatDate(this.fromDate)
      }
      if (this.toDate) {
        filterObj.to_date = this.formatDate(this.toDate)
      }
      this.isLoading = true
      try {
        const data = await this.mjp.get2({
          url: '/wxoa/mp/follow/get/more/',
          query: filterObj,
          mjpType: 'mp'
        })
        this.buildData(data)
      } catch (error) {
        console.error(error)
      }
      this.isLoading = false
    }
  }
}
</script>

<style>
#mpfollows {
  padding: 12px;
}
</style>
